module.exports = "<div class=\"row\">\n    <div class=\"col-xs-10 col-xs-offset-1\">\n        &copy; Global Alliance 2025\n        <span class=\"email\"><a href=\"mailto://ga@btjkorea.org\">ga@btjkorea.org</a></span>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/ko/footer.html
// module id = 896
// module chunks = 1